exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toggle-el[data-v-a243123e] {\n  display: none;\n}\n.container-align[data-v-a243123e] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n.card-status-center[data-v-a243123e]{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n}\n", ""]);

// exports
